module.exports = __webpack_public_path__ + "static/img/airoad_icon3.2a3505f7.png";